<common-modal #modal [title]="title" customClass="text-base max-sm:w-[90%] w-[448px]">
  <ng-container content>
    <div class="p-6 text-slate-600 max-sm:p-3">{{ message }}</div>
    <div class="flex justify-end gap-2 border-t border-slate-200 px-6 py-4 max-sm:px-3 max-sm:py-2">
      <ng-container *ngIf="hasCancel">
        <button class="btn border-none" (click)="close()">
          <span i18n>Cancel</span>
        </button>
      </ng-container>
      <button class="btn btn-{{ confirmColor }}" (click)="modal.close(); onConfirm()">
        <span>{{ confirmText }} </span>
      </button>
    </div>
  </ng-container>
</common-modal>
